import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.04 16.563c-1.19-2.057-3.023-3.532-5.163-4.232a5.626 5.626 0 1 0-5.754 0c-2.14.699-3.974 2.174-5.164 4.232a.625.625 0 1 0 1.082.625c1.472-2.544 4.074-4.063 6.959-4.063s5.487 1.519 6.959 4.063a.627.627 0 0 0 1.047.078.63.63 0 0 0 .035-.703M5.626 7.5a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0"
    }, null, -1)
  ])))
}
export default { render: render }